import typeUtils from "@/common/typeUtils";

export default {
  getKeys() {
    return {
      meterInput: 'meterInput'
    }
  },
  getPath() {
    let pathname = window.location.pathname;
    return pathname.substring(0, pathname.lastIndexOf('/')) + '/';
  },
  setCookie(cname, cvalue, seconds, path) {
    let expires = '';
    if (typeUtils.isNumber(seconds)) {
      let d = new Date()
      d.setTime(d.getTime() + (seconds * 1000))
      expires = 'expires=' + d.toUTCString()
    }
    if (!path) {
      path = this.getPath();
    }
    document.cookie = cname + '=' + cvalue + '; ' + expires + '; path=' + path
  },
  getCookie(cname) {
    let name = cname + '='
    let ca = document.cookie.split(';')
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim()
      if (c.indexOf(name) == 0) return c.substring(name.length, c.length)
    }
    return ''
  },
  isLocalStorage() {
    if (window.localStorage) {
      return true
    } else {
      return false;
    }
  },
  getPathKey(key) {
    return key + '_' + this.getPath();
  },
  setStorage(key, value) {
    if (value) {
      window.localStorage.setItem(this.getPathKey(key), JSON.stringify(value));
    } else {
      window.localStorage.removeItem(this.getPathKey(key));
    }
  },
  getStorage(key) {
    let val = window.localStorage.getItem(this.getPathKey(key));
    if (val) {
      return JSON.parse(val);
    } else {
      return null;
    }
  },
  hasBeforeMeterInputSave() {
    let beforeSave = this.getStorage(this.getKeys().meterInput);
    if (beforeSave) {
      return true;
    } else {
      return false;
    }
  }
}